import styles from './layout.module.scss'
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'
import gsap from 'gsap'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

export const siteTitle = 'Aitria'

const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 320,
      md: 1024,
      lg: 1025,
      xl: 1350,
    },
  },
})

const Layout: React.FC = ({ children }) => {
  const router = useRouter()

  const lpPages = [
    '/services/backend-dev',
    '/services/frontend-dev',
    '/services/designsystem',
    '/services/uiuxdesign-lp2',
    '/services/amazonecs',
    '/services/awsfargate',
    '/services/awsapprunner',
    '/services/gitlab',
    '/services/circleci',
    '/services/awscodepipeline',
    '/services/githubactions',
    '/products/zebra',
  ]

  const isLpPage = lpPages.includes(router.pathname)
  const isFlamingoPage = router.pathname.startsWith('/products/flamingo')

  gsap.config({
    nullTargetWarn: false,
  })

  // ページ離脱時にスクロール位置をリセット（unload は非推奨のため pagehide を使用）
  useEffect(() => {
    const resetScroll = () => {
      window.scrollTo(0, 0)
    }
    window.addEventListener('pagehide', resetScroll)
    return () => {
      window.removeEventListener('pagehide', resetScroll)
    }
  }, [])

  return (
    <>
      <MuiThemeProvider theme={theme}>
        {!isFlamingoPage ? (
          <main className={`${styles.main} ${isLpPage ? styles.lpmain : ''}`}>{children}</main>
        ) : (
          <main className={`${styles.flamingo}`}>{children}</main>
        )}
      </MuiThemeProvider>
    </>
  )
}

export default Layout
